import { render, staticRenderFns } from "./QuantitativeRules.vue?vue&type=template&id=57ccd6ef&"
import script from "./QuantitativeRules.vue?vue&type=script&lang=js&"
export * from "./QuantitativeRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports